import React from 'react';
import PropTypes from 'prop-types';
import AnimatedFollowButton from '../../shared/animated-follow-button';
import { useFollow, useUnfollow } from '../../../services/funds/follow-service';
import { recordFundStatistic } from '../../../services/statistics-service';
import useFundStateStore from '../common/fund-state-hook';

export default function FundFollowButton({ fund }) {
  const btnRef = React.useRef();
  const followed = useFundStateStore(React.useCallback(state => state.followed, []));
  const set = useFundStateStore(React.useCallback(state => state.set, []));
  const [, follow] = useFollow();
  const [, unfollow] = useUnfollow();
  const props = {
    initialStatus: followed,
    buttonName: 'fund-follow-button',
    followAction: () => follow(fund.id),
    unfollowAction: () => unfollow(fund.id),
    collectStats: d => recordFundStatistic(fund.id, `${d ? 'follow' : 'unfollow'}_fund`),
    broadcast: d => set(state => {
      state.followed = d;
    }),
  };

  React.useEffect(() => {
    btnRef.current && btnRef.current.notify(followed);
  }, [followed]);

  return <AnimatedFollowButton ref={btnRef} {...props} />;
}

FundFollowButton.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};
